module.exports = __webpack_public_path__ + "img/h5-text.6742e499.png";